// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../statics/content_text_like.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../statics/content_text_like_hover.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../statics/content_text_negative.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../statics/content_text_negative_hover.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../statics/content_text_regenerate.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../../statics/content_text_regenerate_hover.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../../statics/content_text_like_active.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../../statics/content_text_negative_active.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../../statics/recommend_butn_icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../../../statics/recommend_star.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../../../statics/recommend_star_active.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../../../statics/msg_images_id_like.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../../../statics/msg_images_id_like_hover.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../../../statics/msg_images_id_like_active.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AssistantMessageItem_container__EcERR {
    /* display: flex; */
    margin-top: 11px;
}

.AssistantMessageItem_avatar_box_left__zMI0v,
.AssistantMessageItem_avatar_box_right__en16e {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 5px;
}

.AssistantMessageItem_avatar_box_right__en16e {
    justify-content: flex-end;
}

.AssistantMessageItem_avatar_title__V4hD\\+ {
    font-size: 12px;
    color: #414648;
    margin: 0 5px;
}

.AssistantMessageItem_avatar_img__ZaOXh {
    width: 30px;
    height: 30px;
    border-radius: 50%;
}

.AssistantMessageItem_ai_avatar_img__0fLkC {
    width: 30px;
    height: 30px;
    border-radius: 4px;
}

.AssistantMessageItem_content_box__6gM6e {
    display: flex;
    width: 100%;
}

.AssistantMessageItem_content_box_left__brxyn {
    justify-content: flex-start;
}

.AssistantMessageItem_content_box_right__wuO6u {
    justify-content: flex-end;
}

.AssistantMessageItem_content_time__IDpP3 {
    margin-top: 4px;
    margin-bottom: 4px;
    font-size: 12px;
    color: #999;
}

.AssistantMessageItem_content_text__ZBlMp {
    position: relative;
    display: inline-block;
    padding: 12px;
    position: relative;
}

.AssistantMessageItem_content_left__WZ5lb {
    background-color: #ffffff;
    border-radius: 6px;
}

.AssistantMessageItem_content_left__WZ5lb .markdown-body {
    color: #101417 !important;
    font-size: 12px;
}

.AssistantMessageItem_content_right__qjZiw {
    background-color: #ffffff;
    border-radius: 6px;
}

.AssistantMessageItem_content_right__qjZiw .markdown-body {
    color: #323A45 !important;
    font-size: 12px;
}

.AssistantMessageItem_content_recommend__GTLAd {
    margin-bottom: 40px;
}

.AssistantMessageItem_content_text_butns__Pdrzx {
    position: absolute;
    width: 150px;
    height: 32px;
    right: -200px;
    top: 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background-color: #fff;
}

.AssistantMessageItem_butn__xXSxT {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    margin-right: 5px;
    border-radius: 50%;
    cursor: pointer;
    background-color: #e4f0f2;
}

.AssistantMessageItem_butn__xXSxT:hover {
    background-color: #c6e0e4;
}

.AssistantMessageItem_butn_img__U-ISV {
    width: 16px;
    height: 16px;
}

.AssistantMessageItem_like_img__\\+CG85 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.AssistantMessageItem_butn__xXSxT:hover .AssistantMessageItem_like_img__\\+CG85 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.AssistantMessageItem_negative_img__tTpyh {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.AssistantMessageItem_butn__xXSxT:hover .AssistantMessageItem_negative_img__tTpyh {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.AssistantMessageItem_regenerate_img__sVbRW {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.AssistantMessageItem_butn__xXSxT:hover .AssistantMessageItem_regenerate_img__sVbRW {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.AssistantMessageItem_butn_active__k8D-F,
.AssistantMessageItem_butn_active__k8D-F:hover {
    background-color: #17a8b5;
}

.AssistantMessageItem_butn_active__k8D-F .AssistantMessageItem_like_img__\\+CG85,
.AssistantMessageItem_butn_active__k8D-F:hover .AssistantMessageItem_like_img__\\+CG85 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.AssistantMessageItem_butn_active__k8D-F .AssistantMessageItem_negative_img__tTpyh,
.AssistantMessageItem_butn_active__k8D-F:hover .AssistantMessageItem_negative_img__tTpyh {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.AssistantMessageItem_loading_img__h\\+sIN {
    width: 30px;
    height: 10px;
}

.AssistantMessageItem_recommend_box__j1Oj6 {
    position: absolute;
    right: 0;
    bottom: -40px;
    width: 174px;
    height: 40px;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    cursor: pointer;
    background-color: #e4f0f2;
    transition: background-color 0.5s ease-in-out;
}

.AssistantMessageItem_recommend_box__j1Oj6:hover {
    background-image: linear-gradient(to right, #c6e0e4 50%, #e4f0f2 50%);
    background-size: 200% 100%;
    background-position: left bottom;
    transition: background-color 0.5s ease-in-out, background-position 0.5s ease-in-out;
}

.AssistantMessageItem_recommend_box__j1Oj6:not(:hover) {
    background-position: right bottom;
}

.AssistantMessageItem_recommend_butn_box__RHODj {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}

.AssistantMessageItem_recommend_butn_text__qqv\\+K {
    font-size: 14px;
    color: #17a8b5;
    margin-right: 10px;
}

.AssistantMessageItem_recommend_butn_icon__OQoF2 {
    width: 6px;
    height: 12px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat center / 100% 100%;
    transition: transform 0.5s ease;
}

.AssistantMessageItem_recommend_box__j1Oj6:hover .AssistantMessageItem_recommend_butn_icon__OQoF2 {
    transform: translateX(5px);
}

.AssistantMessageItem_popover_box__pbvbe {
    /* padding: 16px; */
}

.AssistantMessageItem_popover_item__VcNB2 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 160px;
    height: 40px;
    padding-left: 16px;
    padding-bottom: 3px;
    margin-bottom: 3px;
    cursor: pointer;
    border-radius: 6px;
    transition: background 0.5s;
}

.AssistantMessageItem_popover_item__VcNB2:hover {
    background-color: #dfdfdf;
}

.AssistantMessageItem_popover_item__VcNB2:active {
    background-color: #cdcdcd;
}

.AssistantMessageItem_popover_item_text__JQF2j {
    font-size: 14px;
    color: #605D64;
}

.custom_popover_message .ant-popover-inner {
    padding: 0;
    border-radius: 6px;
}

.AssistantMessageItem_recommend_start__8wCr9,
.AssistantMessageItem_recommend_start_active__Q5Syr {
    width: 11px;
    height: 10px;
    margin-top: 3px;
    margin-right: 5px;
}

.AssistantMessageItem_popover_item_img_box__HAgmr {
    display: flex;
}

.AssistantMessageItem_recommend_start__8wCr9 {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) no-repeat center / 100% 100%;
}

.AssistantMessageItem_recommend_start_active__Q5Syr {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) no-repeat center / 100% 100%;
}

.msg_images_id_box {
    display: flex;
    justify-content: center;
    margin: 20px 0;
}

.msg_images_id_container {
    width: 200px;
    height: 200px;
    margin-right: 28px;
    /* margin-bottom: 10px; */
    position: relative;
    overflow: hidden;
    cursor: pointer;
}

.msg_images_id_container:last-child {
    margin-right: 0;
}

.msg_images_id_container_num1,
.msg_images_id_container_num2 {
    width: 342px;
    height: 256px;
}

.msg_images_id_container_num3 {
    width: 220px;
    height: 166px;
}

.msg_images_id {
    width: 100%;
    height: 100%;
    transition: transform 0.3s ease-in-out;
    background-color: #f9f9f9 !important;
}

.AssistantMessageItem_content_thinking__LJ6o3 .msg_images_id_container:hover .msg_images_id {
    transform: none;
}

.msg_images_id_container:hover .msg_images_id {
    transform: scale(1.1);
}

.AssistantMessageItem_content_thinking__LJ6o3 .msg_images_id_overlay {
    display: none;
}

.msg_images_id_overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.15); /* 灰色半透明 */
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
}

.msg_images_id_container:hover .msg_images_id_overlay {
    opacity: 1;
}

.msg_images_id_overlay .msg_images_id_like {
    position: absolute;
    top: 5px;
    right: 5px;
    width: 32px;
    height: 32px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) no-repeat center / 100% 100%;
    transition: background 0.5s;
}

/* 隐藏伪元素用来预加载悬停背景图 */
.msg_images_id_overlay .msg_images_id_like::after {
    content: "";
    background: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat center / 100% 100%;
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    z-index: -1;
}

.msg_images_id_overlay .msg_images_id_like:hover {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat center / 100% 100%;
}

.msg_images_id_overlay .msg_images_id_like_active,
.msg_images_id_overlay .msg_images_id_like_active:hover {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) no-repeat center / 100% 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/components/AssistantMessageItem/index.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,MAAM;IACN,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yDAAkE;AACtE;;AAEA;IACI,yDAAwE;AAC5E;;AAEA;IACI,yDAAsE;AAC1E;;AAEA;IACI,yDAA4E;AAChF;;AAEA;IACI,yDAAwE;AAC5E;;AAEA;IACI,yDAA8E;AAClF;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yDAAyE;AAC7E;;AAEA;;IAEI,yDAA6E;AACjF;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,8BAA8B;IAC9B,+BAA+B;IAC/B,eAAe;IACf,yBAAyB;IACzB,6CAA6C;AACjD;;AAEA;IACI,qEAAqE;IACrE,0BAA0B;IAC1B,gCAAgC;IAChC,mFAAmF;AACvF;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,gFAA2F;IAC3F,+BAA+B;AACnC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gFAAsF;AAC1F;;AAEA;IACI,iFAA6F;AACjG;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,oCAAoC;AACxC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,+BAA+B,EAAE,UAAU;IAC3C,UAAU;IACV,oCAAoC;AACxC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,iFAA0F;IAC1F,2BAA2B;AAC/B;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,iFAAgG;IAChG,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,iFAAgG;AACpG;;AAEA;;IAEI,iFAAiG;AACrG","sourcesContent":[".container {\n    /* display: flex; */\n    margin-top: 11px;\n}\n\n.avatar_box_left,\n.avatar_box_right {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    padding-bottom: 5px;\n}\n\n.avatar_box_right {\n    justify-content: flex-end;\n}\n\n.avatar_title {\n    font-size: 12px;\n    color: #414648;\n    margin: 0 5px;\n}\n\n.avatar_img {\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n}\n\n.ai_avatar_img {\n    width: 30px;\n    height: 30px;\n    border-radius: 4px;\n}\n\n.content_box {\n    display: flex;\n    width: 100%;\n}\n\n.content_box_left {\n    justify-content: flex-start;\n}\n\n.content_box_right {\n    justify-content: flex-end;\n}\n\n.content_time {\n    margin-top: 4px;\n    margin-bottom: 4px;\n    font-size: 12px;\n    color: #999;\n}\n\n.content_text {\n    position: relative;\n    display: inline-block;\n    padding: 12px;\n    position: relative;\n}\n\n.content_left {\n    background-color: #ffffff;\n    border-radius: 6px;\n}\n\n.content_left :global(.markdown-body) {\n    color: #101417 !important;\n    font-size: 12px;\n}\n\n.content_right {\n    background-color: #ffffff;\n    border-radius: 6px;\n}\n\n.content_right :global(.markdown-body) {\n    color: #323A45 !important;\n    font-size: 12px;\n}\n\n.content_recommend {\n    margin-bottom: 40px;\n}\n\n.content_text_butns {\n    position: absolute;\n    width: 150px;\n    height: 32px;\n    right: -200px;\n    top: 0;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    background-color: #fff;\n}\n\n.butn {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 32px;\n    height: 32px;\n    margin-right: 5px;\n    border-radius: 50%;\n    cursor: pointer;\n    background-color: #e4f0f2;\n}\n\n.butn:hover {\n    background-color: #c6e0e4;\n}\n\n.butn_img {\n    width: 16px;\n    height: 16px;\n}\n\n.like_img {\n    background-image: url('../../../../statics/content_text_like.png');\n}\n\n.butn:hover .like_img {\n    background-image: url('../../../../statics/content_text_like_hover.png');\n}\n\n.negative_img {\n    background-image: url('../../../../statics/content_text_negative.png');\n}\n\n.butn:hover .negative_img {\n    background-image: url('../../../../statics/content_text_negative_hover.png');\n}\n\n.regenerate_img {\n    background-image: url('../../../../statics/content_text_regenerate.png');\n}\n\n.butn:hover .regenerate_img {\n    background-image: url('../../../../statics/content_text_regenerate_hover.png');\n}\n\n.butn_active,\n.butn_active:hover {\n    background-color: #17a8b5;\n}\n\n.butn_active .like_img,\n.butn_active:hover .like_img {\n    background-image: url('../../../../statics/content_text_like_active.png');\n}\n\n.butn_active .negative_img,\n.butn_active:hover .negative_img {\n    background-image: url('../../../../statics/content_text_negative_active.png');\n}\n\n.loading_img {\n    width: 30px;\n    height: 10px;\n}\n\n.recommend_box {\n    position: absolute;\n    right: 0;\n    bottom: -40px;\n    width: 174px;\n    height: 40px;\n    border-bottom-left-radius: 6px;\n    border-bottom-right-radius: 6px;\n    cursor: pointer;\n    background-color: #e4f0f2;\n    transition: background-color 0.5s ease-in-out;\n}\n\n.recommend_box:hover {\n    background-image: linear-gradient(to right, #c6e0e4 50%, #e4f0f2 50%);\n    background-size: 200% 100%;\n    background-position: left bottom;\n    transition: background-color 0.5s ease-in-out, background-position 0.5s ease-in-out;\n}\n\n.recommend_box:not(:hover) {\n    background-position: right bottom;\n}\n\n.recommend_butn_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n}\n\n.recommend_butn_text {\n    font-size: 14px;\n    color: #17a8b5;\n    margin-right: 10px;\n}\n\n.recommend_butn_icon {\n    width: 6px;\n    height: 12px;\n    background: url('../../../../statics/recommend_butn_icon.png') no-repeat center / 100% 100%;\n    transition: transform 0.5s ease;\n}\n\n.recommend_box:hover .recommend_butn_icon {\n    transform: translateX(5px);\n}\n\n.popover_box {\n    /* padding: 16px; */\n}\n\n.popover_item {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 160px;\n    height: 40px;\n    padding-left: 16px;\n    padding-bottom: 3px;\n    margin-bottom: 3px;\n    cursor: pointer;\n    border-radius: 6px;\n    transition: background 0.5s;\n}\n\n.popover_item:hover {\n    background-color: #dfdfdf;\n}\n\n.popover_item:active {\n    background-color: #cdcdcd;\n}\n\n.popover_item_text {\n    font-size: 14px;\n    color: #605D64;\n}\n\n:global(.custom_popover_message .ant-popover-inner) {\n    padding: 0;\n    border-radius: 6px;\n}\n\n.recommend_start,\n.recommend_start_active {\n    width: 11px;\n    height: 10px;\n    margin-top: 3px;\n    margin-right: 5px;\n}\n\n.popover_item_img_box {\n    display: flex;\n}\n\n.recommend_start {\n    background: url('../../../../statics/recommend_star.png') no-repeat center / 100% 100%;\n}\n\n.recommend_start_active {\n    background: url('../../../../statics/recommend_star_active.png') no-repeat center / 100% 100%;\n}\n\n:global(.msg_images_id_box) {\n    display: flex;\n    justify-content: center;\n    margin: 20px 0;\n}\n\n:global(.msg_images_id_container) {\n    width: 200px;\n    height: 200px;\n    margin-right: 28px;\n    /* margin-bottom: 10px; */\n    position: relative;\n    overflow: hidden;\n    cursor: pointer;\n}\n\n:global(.msg_images_id_container:last-child) {\n    margin-right: 0;\n}\n\n:global(.msg_images_id_container_num1),\n:global(.msg_images_id_container_num2) {\n    width: 342px;\n    height: 256px;\n}\n\n:global(.msg_images_id_container_num3) {\n    width: 220px;\n    height: 166px;\n}\n\n:global(.msg_images_id) {\n    width: 100%;\n    height: 100%;\n    transition: transform 0.3s ease-in-out;\n    background-color: #f9f9f9 !important;\n}\n\n.content_thinking :global(.msg_images_id_container:hover .msg_images_id) {\n    transform: none;\n}\n\n:global(.msg_images_id_container:hover .msg_images_id) {\n    transform: scale(1.1);\n}\n\n.content_thinking :global(.msg_images_id_overlay) {\n    display: none;\n}\n\n:global(.msg_images_id_overlay) {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.15); /* 灰色半透明 */\n    opacity: 0;\n    transition: opacity 0.3s ease-in-out;\n}\n\n:global(.msg_images_id_container:hover .msg_images_id_overlay) {\n    opacity: 1;\n}\n\n:global(.msg_images_id_overlay .msg_images_id_like) {\n    position: absolute;\n    top: 5px;\n    right: 5px;\n    width: 32px;\n    height: 32px;\n    background: url('../../../../statics/msg_images_id_like.png') no-repeat center / 100% 100%;\n    transition: background 0.5s;\n}\n\n/* 隐藏伪元素用来预加载悬停背景图 */\n:global(.msg_images_id_overlay .msg_images_id_like::after) {\n    content: \"\";\n    background: url('../../../../statics/msg_images_id_like_hover.png') no-repeat center / 100% 100%;\n    position: absolute;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    z-index: -1;\n}\n\n:global(.msg_images_id_overlay .msg_images_id_like:hover) {\n    background: url('../../../../statics/msg_images_id_like_hover.png') no-repeat center / 100% 100%;\n}\n\n:global(.msg_images_id_overlay .msg_images_id_like_active),\n:global(.msg_images_id_overlay .msg_images_id_like_active:hover) {\n    background: url('../../../../statics/msg_images_id_like_active.png') no-repeat center / 100% 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AssistantMessageItem_container__EcERR`,
	"avatar_box_left": `AssistantMessageItem_avatar_box_left__zMI0v`,
	"avatar_box_right": `AssistantMessageItem_avatar_box_right__en16e`,
	"avatar_title": `AssistantMessageItem_avatar_title__V4hD+`,
	"avatar_img": `AssistantMessageItem_avatar_img__ZaOXh`,
	"ai_avatar_img": `AssistantMessageItem_ai_avatar_img__0fLkC`,
	"content_box": `AssistantMessageItem_content_box__6gM6e`,
	"content_box_left": `AssistantMessageItem_content_box_left__brxyn`,
	"content_box_right": `AssistantMessageItem_content_box_right__wuO6u`,
	"content_time": `AssistantMessageItem_content_time__IDpP3`,
	"content_text": `AssistantMessageItem_content_text__ZBlMp`,
	"content_left": `AssistantMessageItem_content_left__WZ5lb`,
	"content_right": `AssistantMessageItem_content_right__qjZiw`,
	"content_recommend": `AssistantMessageItem_content_recommend__GTLAd`,
	"content_text_butns": `AssistantMessageItem_content_text_butns__Pdrzx`,
	"butn": `AssistantMessageItem_butn__xXSxT`,
	"butn_img": `AssistantMessageItem_butn_img__U-ISV`,
	"like_img": `AssistantMessageItem_like_img__+CG85`,
	"negative_img": `AssistantMessageItem_negative_img__tTpyh`,
	"regenerate_img": `AssistantMessageItem_regenerate_img__sVbRW`,
	"butn_active": `AssistantMessageItem_butn_active__k8D-F`,
	"loading_img": `AssistantMessageItem_loading_img__h+sIN`,
	"recommend_box": `AssistantMessageItem_recommend_box__j1Oj6`,
	"recommend_butn_box": `AssistantMessageItem_recommend_butn_box__RHODj`,
	"recommend_butn_text": `AssistantMessageItem_recommend_butn_text__qqv+K`,
	"recommend_butn_icon": `AssistantMessageItem_recommend_butn_icon__OQoF2`,
	"popover_box": `AssistantMessageItem_popover_box__pbvbe`,
	"popover_item": `AssistantMessageItem_popover_item__VcNB2`,
	"popover_item_text": `AssistantMessageItem_popover_item_text__JQF2j`,
	"recommend_start": `AssistantMessageItem_recommend_start__8wCr9`,
	"recommend_start_active": `AssistantMessageItem_recommend_start_active__Q5Syr`,
	"popover_item_img_box": `AssistantMessageItem_popover_item_img_box__HAgmr`,
	"content_thinking": `AssistantMessageItem_content_thinking__LJ6o3`
};
export default ___CSS_LOADER_EXPORT___;
